import { Stack } from '@mui/material';
import { GettingStartNote } from '../GettingStartNote';
import { UploadFileArea } from '../UploadFileArea';
import { FileNote } from '../FileNote';
import { BackButton } from '../BackButton';

export const GettingStartedSection = () => {
  return (
    <Stack sx={{ gap: '32px', maxWidth: '800px', m: '0 auto' }}>
      <GettingStartNote />
      <UploadFileArea />
      <FileNote />
      <BackButton />
    </Stack>
  );
};
